<template>
  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div style="min-height: 80px"
         v-if="iteminfo.config.displayType === 2 && iteminfo.config.columnCount ==1">
      <ul>
        <li :key="index" v-for="(item,index) in getshowDataList">
          <img :src="getItemPic(item)"
               class="w-full h-full"
               style="cursor: pointer;vertical-align: top;object-fit: fill"/>
        </li>
      </ul>
    </div>
    <div style="min-height: 72px"
         :style="{paddingLeft:getItemHPadding,paddingRight:getItemHPadding,paddingTop:getItemVPadding,paddingBottom:getItemVPadding}"
         v-if="iteminfo.config.displayType === 2  && iteminfo.config.columnCount == 2">
      <ul class="flex j-start flex-wrap">
        <li :key="index" class="flex-s-0"
            style="width: 50%"
            :style="{paddingLeft:getItemHPadding,paddingRight:getItemHPadding,paddingTop:getItemVPadding,paddingBottom:getItemVPadding}"
            v-for="(item,index) in getshowDataList">
          <ratio-div :RadioValue="75">
            <div class="w-full h-full absolute top-0 left-0 flex a-center j-center o-hidden">
              <img :src="getTwoItemPic(item)"
                   class="w-full  h-full"
                   style="cursor: pointer;object-fit: fill"/>
            </div>
          </ratio-div>
        </li>
      </ul>
    </div>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'

export default {
  name: 'PicDisplayWidget',
  components: {RatioDiv, BaseDisplayWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {}
  },
  computed: {
    getshowDataList () {
      let list = []
      list = this.getDefaultProductList()
      return list
    },
    getItemHPadding () {
      return (this.iteminfo.config.hSpacing / 2) + 'px'
    },
    getItemVPadding () {
      return (this.iteminfo.config.vSpacing / 2) + 'px'
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    getItemPic (item) {
      let src = require('../../../assets/tempmenu/img_picture_single.png')
      if (item.picurl) {
        src = item.picurl
      }
      return src
    },
    getTwoItemPic (item) {
      let src = require('../../../assets/tempmenu/img_picture_abreast.png')
      if (item.picurl) {
        src = item.picurl
      }
      return src
    },
    getDefaultProductList () {
      // let templist = []
      // let length = 1
      // if (this.iteminfo.config.displayType === 1) {
      //   length = 1
      // } else if (this.iteminfo.config.displayType === 2) {
      //   length = 2
      // }
      // let len = this.iteminfo.config.datalist.length || 0
      // if (length <= len) {
      //   templist = this.iteminfo.config.datalist
      // } else {
      //   templist = templist.concat(this.iteminfo.config.datalist)
      //   for (let i = 0; i < (length - len); i++) {
      //     templist.push({
      //       id: 0,
      //       picurl: '',
      //       title: ''
      //     })
      //   }
      // }
      // return templist
      return this.iteminfo.config.datalist
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
